import uniqueId from "lodash/uniqueId";
import {
  GET_DI_VIEWMODEL_REQUEST,
  GET_DI_VIEWMODEL_SUCCESS,
  GET_DI_VIEWMODEL_ERROR,
  GET_SUGGESTIONS_SUCCESS,
  GET_SUGGESTIONS_ERROR,
  CLEAR_SUGGESTIONS,
  UPDATE_INPUT,
  RESET_FORM,
  ADD_INPUT,
  REMOVE_INPUT,
  GET_DI_DETAILS_VIEWMODEL_SUCCESS,
  GET_DI_DETAILS_VIEWMODEL_ERROR,
  SET_INTERACTING_DETAILS,
  CLEAR_INTERACTING_DETAILS,
  GET_DI_RESULTS_REQUEST,
  GET_DI_RESULTS_SUCCESS,
  GET_DI_RESULTS_ERROR,
  SET_SELECTED_INTERACTION_TYPE,
  CACHE_PREVIOUS_DRUGS_CODES,
} from "../actionTypes";

export const DEFAULT_SELECTED_TYPE = "DRUG";

const buildInput = () => ({ id: uniqueId(), value: "" });

const getInitialInputs = () => [buildInput(), buildInput()];
const defaultInputs = getInitialInputs();
const buildInitialDrugInteractionsDetails = () => ({
  viewModel: null,
  metaData: {
    severity: null,
    apiPath: null,
    interactingDrugName: null,
  },
  error: null,
});

export const initialState = {
  isFetching: false,
  drugInteractionsViewModel: null,
  isResultsFetching: false,
  resultsViewModel: null,
  checkerErrorViewModel: null,
  resultsErrorViewModel: null,
  inputs: defaultInputs,
  defaultNumberOfInputs: defaultInputs.length,
  autosuggest: {
    suggestions: [],
    searchCondition: "",
    hasFetched: false,
    hasError: false,
  },
  drugDetail: buildInitialDrugInteractionsDetails(),
  isSeverityModalVisible: false,
  selectedInteractionType: DEFAULT_SELECTED_TYPE,
  cachedDrugsCodes: [],
};

export const drugInteractionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CACHE_PREVIOUS_DRUGS_CODES: {
      return {
        ...state,
        cachedDrugsCodes: action.payload || [],
      };
    }
    case GET_DI_VIEWMODEL_REQUEST:
      return {
        ...state,
        isFetching: true,
        checkerErrorViewModel: null,
        resultsErrorViewModel: null,
      };
    case GET_DI_VIEWMODEL_SUCCESS:
      return {
        ...state,
        drugInteractionsViewModel: action.payload,
        isFetching: false,
      };
    case GET_DI_VIEWMODEL_ERROR:
      return {
        ...state,
        isFetching: false,
        checkerErrorViewModel: action.payload,
      };
    case UPDATE_INPUT: {
      const newInput = action.payload;
      const inputs = state.inputs.map((input) =>
        input.id === newInput.id ? newInput : input
      );
      return {
        ...state,
        inputs,
        resultsViewModel: null,
        cachedDrugsCodes: [],
      };
    }
    case GET_SUGGESTIONS_SUCCESS: {
      const { suggestions, searchCondition } = action.payload;
      return {
        ...state,
        autosuggest: {
          suggestions,
          searchCondition,
          hasFetched: true,
          hasError: false,
        },
      };
    }
    case GET_SUGGESTIONS_ERROR:
      return {
        ...state,
        autosuggest: {
          suggestions: [],
          hasFetched: true,
          hasError: true,
        },
      };
    case CLEAR_SUGGESTIONS:
      return {
        ...state,
        autosuggest: {
          suggestions: [],
          searchCondition: "",
          hasFetched: false,
          hasError: false,
        },
      };
    case RESET_FORM:
      return {
        ...state,
        inputs: getInitialInputs(),
        resultsViewModel: null,
      };
    case ADD_INPUT:
      return {
        ...state,
        inputs: [...state.inputs, buildInput()],
        resultsViewModel: null,
      };
    case REMOVE_INPUT:
      return {
        ...state,
        inputs: state.inputs.filter((input) => input.id !== action.payload.id),
        resultsViewModel: null,
      };
    case GET_DI_DETAILS_VIEWMODEL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        drugDetail: {
          ...state.drugDetail,
          viewModel: action.payload,
        },
      };
    case GET_DI_DETAILS_VIEWMODEL_ERROR:
      return {
        ...state,
        isFetching: false,
        drugDetail: {
          ...state.drugDetail,
          error: action.payload,
        },
      };
    case SET_INTERACTING_DETAILS:
      return {
        ...state,
        drugDetail: {
          ...state.drugDetail,
          metaData: action.payload,
        },
      };
    case CLEAR_INTERACTING_DETAILS:
      return {
        ...state,
        drugDetail: buildInitialDrugInteractionsDetails(),
      };
    case GET_DI_RESULTS_REQUEST:
      return {
        ...state,
        isResultsFetching: true,
        resultsViewModel: null,
        resultsErrorViewModel: null,
      };
    case GET_DI_RESULTS_SUCCESS:
      const { filterControls } = action.payload.content;
      const [firstInteractionType] = filterControls?.options;
      const selectedInteractionType =
        firstInteractionType?.type || DEFAULT_SELECTED_TYPE;
      return {
        ...state,
        isResultsFetching: false,
        resultsViewModel: action.payload,
        selectedInteractionType,
      };
    case GET_DI_RESULTS_ERROR:
      return {
        ...state,
        isResultsFetching: false,
        resultsErrorViewModel: action.payload,
      };
    case SET_SELECTED_INTERACTION_TYPE:
      return {
        ...state,
        selectedInteractionType: action.payload,
      };
    default:
      return state;
  }
};
